import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadProjectSettlements } from "@/schemas/projectSettlements";
import { FilterType } from "@/lib/filters";
import { ReadProjectRole } from "@/types/projectRoleType";

export const ProjectSettlementService = new APIService<ReadProjectSettlements>(
  API.ProjectSettlements,
);

export const getProjectSettlementsListGetter =
  (projectId: string) => (fetchParams: FetchListRequest<ReadProjectRole>) =>
    ProjectSettlementService.getList({
      ...fetchParams,
      filters: [
        {
          id: "project_id",
          value: {
            value: projectId,
            filter: FilterType.EqualsString,
          },
        },
      ],
    });

export const approveProjectSettlement = (settlementId: string) =>
  ProjectSettlementService.patch(settlementId, {}, "approve");

export const closeProjectSettlement = (settlementId: string) =>
  ProjectSettlementService.patch(settlementId, {}, "close");

export const rejectProjectSettlement = (settlementId: string) =>
  ProjectSettlementService.patch(settlementId, {}, "reject");

export const reopenProjectSettlement = (settlementId: string) =>
  ProjectSettlementService.patch(settlementId, {}, "reopen");
